<template>
    <div class="mian_box">
        <div class="line"></div>
        <div class="project_box">
            <div class="people" v-for="(item,index) in process" :key="index">
                <div class="pic">
                    <div class="img" v-for="(item,index) in item.managerList" :key="index">
                        <img :src="item.avatar" />
                        <span>{{item.realname}}</span>
                    </div>
                    <div class="name_time">
                        <div class="txt1" v-if="item.title">{{item.title}}</div>
                        <div v-if="item.status">{{'('+item.status+')'}}</div>
                    </div>
                </div>
                <div class="con">
                    <div class="txt2">
                        <div class>
                            <span>{{item.content}}</span>
                        </div>
                        <!-- <div v-for="(itemL,index) in item.images" :key="index">
                                <el-image                                     
                                    style="width: 50px; height: 50px"
                                    :src="itemk" 
                                    :preview-src-list="items.images">
                                </el-image>
                        </div>-->
                        <div class v-for="(items,indexs) in item.comments" :key="indexs">
                            <span>{{items.username}}</span>
                            <span>{{items.content}}</span>
                            <div v-for="(itemk,index) in items.images" :key="index">
                                <el-image
                                    style="width: 50px; height: 50px"
                                    :src="itemk"
                                    :preview-src-list="items.images"
                                ></el-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="time">{{item.confirm_time}}</div>
            </div>
        </div>

        <div class="btn_box">
            <!-- <div class="box" @click="isReview=!isReview;submitType='review'">
                <img src="@/assets/img/approval/comment.png" />
                <text>评论</text>
            </div> -->
            <div
                class="button_box refuse"
                v-if="confirm.btn.length!=0&&confirm.btn.acceptAll"
                @click="isReview=!isReview;isShowUpload=false;submitType='acceptAll'"
            >{{confirm.btn.acceptAll.title}}</div>
            <div
                class="button_box refuse"
                v-if="confirm.btn.length!=0&&confirm.btn.reject"
                @click="isReview=!isReview;isShowUpload=false;submitType='reject'"
            >{{confirm.btn.reject.title}}</div>
            <div
                class="button_box agree"
                v-if="confirm.btn.length!=0&&confirm.btn.accept"
                @click="isReview=!isReview;isShowUpload=false;submitType='accept'"
            >{{confirm.btn.accept.title}}</div>
        </div>

        <div class="Review_box" v-show="isReview">
            <div v-if="isShowUpload">
                <el-upload
                    :action="https+'/api/order.upload/doupload'"
                    list-type="picture-card"
                    :file-list="fileList"
                    :data="uploadOptions"
                    ref="upload"
                    :on-success="handleAvatarSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </div>
            <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4}"
                placeholder="请输入评论内容"
                v-model="review.value"
            ></el-input>
            <div class="buttonbox">
                <div class="button_box refuse" @click="isReview=!isReview;">取消</div>
                <div class="button_box agree" @click="submit">提交</div>
            </div>
        </div>
    </div>
</template>
<script>
import { http } from '@/api/http.js';
export default {
    props: {
        process: {
            type: Array,
            default: () => {
                return [
                    {
                        comments: [],
                        confirm_time: '08-10 11:01',
                        content: '测试',
                        id: 'coo',
                        image: [],
                        managerList: [
                            {
                                id: 710,
                                realname: '张冰洁',
                                avatar: 'https://www.yusivip.com/upload/commonAppimg/hs_app_logo.png'
                            }
                        ],
                        status: '审核通过',
                        title: '运营总监'
                    },
                    {
                        comments: [],
                        confirm_time: '08-10 11:01',
                        content: '测试',
                        id: 'coo',
                        image: [],
                        managerList: [
                            {
                                id: 710,
                                realname: '张冰洁',
                                avatar: 'https://www.yusivip.com/upload/commonAppimg/hs_app_logo.png'
                            }
                        ],
                        status: '审核通过',
                        title: '运营总监'
                    }
                ];
            }
        },
        confirm: {
            type: Object,
            default: () => {
                return {
                    btn: []
                };
            }
        }
    },
    data() {
        return {
            https: 'https://crm.hongsizg.com',
            uploadOptions: {},
            isReview: false,
            review: {
                value: '',
                imgaArray: []
            },
            fileList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            isShowUpload: true,
            submitType: '' //review 评论提交，acceptAll所有提交  ，reject拒绝  accept同意
        };
    },
    created() {
        this.uploadOptions['token'] = localStorage.getItem('token');
    },
    mounted() {},
    methods: {
        handleAvatarSuccess(res, file, fileList) {
            this.fileList = fileList;
        },

        handleRemove(file, fileList) {
            let url = 'api/order.upload/remove';
            let data = { url: file.response.data.url };
            this.$post(url, data).then((res) => {
                this.$message(res.msg);
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submit() {
            if (this.submitType == 'review') {
                this.reviewFn();
            } else if (this.submitType == 'acceptAll') {
                this.acceptAllFn();
            } else if (this.submitType == 'reject') {
                this.rejectFn();
            } else if (this.submitType == 'accept') {
                this.acceptFn();
            }
        },
        reviewFn() {
              this.$confirm(' 是否继续此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                 let url = '/api/order.comment/create';
                let data = {
                    confirm_id: this.confirm.id,
                    content: this.review.value,
                    image: this.fileList
                        .map((item, index) => {
                            return item.response.data.url;
                        })
                        .join(',')
                };
                this.$post(url, data).then((res) => {
                    this.isReview = !this.isReview;
                    this.$refs.upload.clearFiles();
                    this.review = {
                        value: '',
                        imgaArray: ''
                    };
                     this.$message({
                            type: 'success',
                            message: res.msg
                        });
                    this.$emit('aecallApi', 'ok');
                    this.$emit('afreshApiShopOrder', 'ok');
                });
            }).catch(()=>{
                 this.$message({
                        type: 'info',
                        message: '已取消'
                    });
            })
           
        },
        rejectFn() {
             this.$confirm(' 是否继续此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                   this.isShowUpload = false;
                    let url = '/api/order.confirm/reject';
                    let data = {
                        id: this.confirm.id,
                        content: this.review.value
                    };
                    this.$post(url, data).then((res) => {
                        this.isShowUpload = true;
                        this.isReview = !this.isReview;
                        this.review = {
                            value: '',
                            imgaArray: ''
                        };
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                        this.$emit('aecallApi', 'ok');
                        this.$emit('afreshApiShopOrder', 'ok');
                    });
            }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
          
        },
        acceptAllFn() {
            this.$confirm(' 是否继续此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.isShowUpload=false
                    let url = '/api/order.confirm/acceptAll';
                    let data = {
                        id: this.confirm.id,
                        content: this.review.value
                    };
                    this.$post(url, data).then((res) => {
                        this.isShowUpload=true
                        this.isReview = !this.isReview;
                        this.review = {
                            value: '',
                            imgaArray: ''
                        };
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                        this.$emit('aecallApi', 'ok');
                        this.$emit("afreshApiShopOrder","ok") 
                    });
                    
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        acceptFn() {
             this.$confirm(' 是否继续此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.isShowUpload = false;
                let url = '/api/order.confirm/accept';
                let data = {
                    id: this.confirm.id,
                    content: this.review.value
                };
                this.$post(url, data).then((res) => {
                    this.isShowUpload = true;
                    this.isReview = !this.isReview;
                    this.review = {
                        value: '',
                        imgaArray: ''
                    };
                    this.$message(res.msg);
                    this.$emit('aecallApi', 'ok');
                });
            }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
           
        }
    }
};
</script>


<style >
.el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 70px;
}
.el-upload-list--picture-card .el-upload-list__item {
    width: 70px;
    height: 70px;
}
</style>
<style scoped lang="less">
.mian_box {
    width: 100%;
    height: 100%;
    // padding: 30px;
    box-sizing: border-box;
    position: relative;
}

.line {
    width: 100%;
    height: 8px;
    background: rgba(246, 246, 246, 1);
}
.project_box {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 20px 16px;
    box-sizing: border-box;
    position: relative;
}
.people {
    width: 100%;
    display: flex;
    position: relative;
    .pic {
        width: 80%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: left;
        align-items: center;
        .img {
            min-width: 80px;
            position: relative;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-right: 5px;
            span {
                font-size: 10px;
            }
            img {
                width: 40px;
                border-radius: 50%;
            }
        }
        span {
            font-size: 14px;
        }
        .name_time {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
        }
    }
    .con {
        width: auto;
        margin-left: 42px;
        margin-top: 62px;
        // padding-top: 100px;
        span {
            width: auto;
            display: block;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            padding-left: 38px;
            box-sizing: border-box;
        }
        .txt1 {
            font-size: 17px;
            color: rgba(51, 51, 51, 1);
        }
        .txt2 {
            width: 100%;
            padding-left: 38px;
            padding-bottom: 15px;
            box-sizing: border-box;
            min-height: 51px;
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            border-left: 2px solid #d3d3d3;
            span {
                padding-left: 0;
                display: block;
            }
            img {
                width: 50px;
                height: 50px;
                border-radius: 0;
                margin-top: 5px;
                margin-right: 10px;
                border: 1px solid #cccccc;
            }
        }
    }
    .time {
        min-width: 68px;
        height: auto;
        position: absolute;
        right: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
    }
}
.people:last-child .con .txt2 {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    border-left: none;
}

//底部选择
.btn_box {
    width: 100%;
    height: 60px;
    // position: fixed;
    // right: 0;
    // bottom: 0;
    background: #ffffff;
    border-top: 1px solid #eeeeee;
    z-index: 5;
    box-sizing: border-box;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .box {
        min-width: 22px;
        text-align: center;
        img {
            width: 22px;
            height: 22px;
        }
        span {
            font-size: 1px;
            color: rgba(102, 102, 102, 1);
            display: block;
        }
    }
    .button_box {
        padding: 5px 8px;
        border-radius: 2px 0px 0px 2px;
        border: 1px solid rgba(208, 220, 255, 1);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
    }
    .refuse {
        background: #ffffff;
        color: rgba(64, 108, 235, 1);
    }
    .agree {
        background: rgba(64, 108, 235, 1);
        color: rgba(255, 255, 255, 1);
    }
}

.bottom_box {
    width: 100%;
    height: 150px;
    height: 50vh;
    background: #f1f1f1;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    .comment_img {
        img {
            width: 100px;
            height: 50px;
        }
    }
    .send_comment {
        width: 100%;

        padding-top: 15px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 15px;
        .img_icon {
            width: 100%;
            border-bottom: 1px solid #dddddd;
            margin-bottom: 15px;
            padding-left: 10px;
            display: flex;
            justify-content: left;
            img {
                width: 25px;
                height: 25px;
                margin-left: 10px;
            }
        }
        button {
            width: 600px;
            font-size: 15px;
            background: #007aff;
            color: #ffffff;
        }
    }
}
.right_close {
    font-size: 14px;
    color: #cccccc;
    position: absolute;
    right: 15px;
    top: 15px;
}

.Review_box {
    width: 100%;
    min-height: 300px;
    height: auto;
    background: #f4f4f4;
    position: absolute;
    bottom: 0;
    left: 0;
    .buttonbox {
        width: 100%;
        position: absolute;
        bottom: 10px;
        left: 0;
        display: flex;
        justify-content: space-around;
        .button_box {
            padding: 5px 8px;
            border-radius: 2px 0px 0px 2px;
            border: 1px solid rgba(208, 220, 255, 1);
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
        }
        .refuse {
            background: #ffffff;
            color: rgba(64, 108, 235, 1);
        }
        .agree {
            background: rgba(64, 108, 235, 1);
            color: rgba(255, 255, 255, 1);
        }
    }
}
</style>
